import React from "react";
import { Modal } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";

// icons
import { MdClose, MdSave } from "react-icons/md";
import "./checkout-theme.css";

export default function ConfirmCOD({
  isShipMentPaytype,
  setIsShipMentPayType,
  handleCloseCodModal,
}) {
  // Validation schema using Yup
  const validationSchema = Yup.object({
    fullName: Yup.string().required("ກະລຸນາປ້ອນຊື່ລູກຄ້າ!"),
    phoneNumber: Yup.string()
      .matches(
        /^(020|030)[0-9]{6,9}$/,
        "ເບີໂທຕ້ອງເປີດດ້ວຍ 020 ຫຼື 030 ແລະຕ້ອງມີ 10-11 ຕົວເລກ",
      )
      .required("ກະລຸນາປ້ອນເບີໂທຕິດຕໍ່"),
    identityCard: Yup.string().nullable(),
    remark: Yup.string().required("ກະລຸນາປ້ອນໝາຍເຫດ ຫຼື ຄຳອະທິບາຍ!"),
  });

  const handleSubmit = (values) => {
    setIsShipMentPayType((prev) => ({
      ...prev,
      isOpenCod: false, // Close modal
      data: values, // Save form values to state
    }));
  };

  return (
    <React.Fragment>
      <Modal
        centered
        show={isShipMentPaytype?.isOpenCod}
        onHide={handleCloseCodModal}
        // Modal portal ອອກນອກ .cf-checkout — ຕິດ class ນີ້ຈຶ່ງໄດ້ font ຊຸດດຽວກັບໜ້າ checkout
        contentClassName="cf-dialog"
      >
        <Formik
          initialValues={{
            fullName: "",
            phoneNumber: "",
            identityCard: "",
            remark: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <FormikForm className="cf-dialog__body" style={{ textAlign: "left" }}>
              {/* ຫົວຂໍ້ຢູ່ໃນ body ບໍ່ໃຊ້ Modal.Header — ຄຸມ style ໄດ້ເອງ ແລະ ຫຍໍ້ໃຫ້ສັ້ນລົງ */}
              <div className="cf-dialog__title" style={{ textAlign: "left" }}>
                ຂໍ້ມູນຜູ້ຮັບເຄື່ອງ (COD)
              </div>

              <div className="cf-field">
                <label className="cf-field__label" htmlFor="cod-fullName">
                  ຊື່ລູກຄ້າ <span className="cf-field__required">*</span>
                </label>
                <Field
                  id="cod-fullName"
                  name="fullName"
                  autoComplete="name"
                  className={`cf-input${touched.fullName && errors.fullName ? " cf-input--invalid" : ""}`}
                  placeholder="ປ້ອນຊື່..."
                />
                <ErrorMessage name="fullName" component="div" className="cf-field__error" />
              </div>

              <div className="cf-field">
                <label className="cf-field__label" htmlFor="cod-phoneNumber">
                  ເບີໂທຕິດຕໍ່ <span className="cf-field__required">*</span>
                </label>
                <Field
                  id="cod-phoneNumber"
                  name="phoneNumber"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel"
                  className={`cf-input${touched.phoneNumber && errors.phoneNumber ? " cf-input--invalid" : ""}`}
                  placeholder="ປ້ອນເບີໂທ..."
                />
                <ErrorMessage name="phoneNumber" component="div" className="cf-field__error" />
              </div>

              <div className="cf-field">
                <label className="cf-field__label" htmlFor="cod-identityCard">
                  ເລກບັດປະຈຳຕົວ (ຖ້າມີ)
                </label>
                <Field
                  id="cod-identityCard"
                  name="identityCard"
                  inputMode="numeric"
                  className="cf-input"
                  placeholder="ປ້ອນເລກບັດ..."
                />
                <ErrorMessage name="identityCard" component="div" className="cf-field__error" />
              </div>

              <div className="cf-field">
                <label className="cf-field__label" htmlFor="cod-remark">
                  ຄຳອະທິບາຍ <span className="cf-field__required">*</span>
                </label>
                <Field
                  id="cod-remark"
                  as="textarea"
                  rows={3}
                  name="remark"
                  className="cf-input cf-textarea"
                  placeholder="ປ້ອນຄຳອະທິບາຍ..."
                />
                <ErrorMessage name="remark" component="div" className="cf-field__error" />
              </div>

              <div className="cf-actions">
                <button type="submit" className="cf-btn cf-btn--primary">
                  <MdSave aria-hidden="true" /> ບັນທຶກ
                </button>
                <button type="button" className="cf-btn cf-btn--secondary" onClick={handleCloseCodModal}>
                  <MdClose aria-hidden="true" /> ຍົກເລີກ
                </button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </Modal>
    </React.Fragment>
  );
}
